export default {
    create_clip_request_title: "Crear Clip",
    create_clip_range: "Rango",
    create_clip_start_date: "Fecha de inicio",
    create_clip_end_date: "Fecha final",
    create_clip_duration: "Duración (segundos)",
    create_clip_max: "El número máximo requerido es",
    create_clip_min: "El número mínimo requerido es",
    create_clip_get_clip: "Obtener clip",
    create_clip_error_range: "Las fechas configuradas están fuera de rango",
    create_clip_no_data: "Sin datos",
    create_clip_success_message: "El clip se ha solicitado correctamente",
    create_clip_error_clip: "Error al solicitar el clip",
    create_clip_already_exists: "Este clip ya existe",
}